import React, { FC } from 'react';
import { ReactComponent as PrevArrowIcon } from '../../../assets/icons/prev-arrow.svg';
import { ReactComponent as NextArrowIcon } from '../../../assets/icons/next-arrow.svg';
import './presenter-slide-carousel.scss';
import PresenterSlideDescription from '../presenter-slide-description/presenter-slide-description';
import PresenterSlideView from './presenter-slide-view';
import Clicker from './clicker/clicker';
import { useStore } from '../../../store/store-provider';
import { observer } from 'mobx-react';
import {
  CuePointMetadata,
} from '../../../store/presenter-slide-management-store/presentation-config-aggregate/presentation-config-aggregate-types/presentation-config-aggregate-types';

interface IProps {
  isClickerMobileTab: boolean;
}

export interface ISubSlideCarouselComponentsProps {
  currentSlide?: CuePointMetadata;
  numberOfSlides?: number;
  currentSlideIndex: number;
  prevArrowDisabledClass: string;
  nextArrowDisabledClass: string;
  onNextSlideHandler: () => void;
  onPrevSlideHandler: () => void;
  onFullscreenHandler: () => void;
}

const PresenterSlideCarousel: FC<IProps> = ({ isClickerMobileTab }): JSX.Element => {
  const { slideManagementStore } = useStore();
  const {
    getSlideManagementEntity,
    isPrevArrowDisabled,
    isNextArrowDisabled,
    goToNextSlideAction,
    goToPrevSlideAction,
    toggleFullscreenModeAction
  } = slideManagementStore;
  const { getActivePointer, getNumberOfSlides } = getSlideManagementEntity();
  const isClickerTabOnMobile: string = isClickerMobileTab ? 'isClickerMobileTab' : '';
  const prevArrowDisabledClass: string = isPrevArrowDisabled() ? 'disabled' : '';
  const nextArrowDisabledClass: string = isNextArrowDisabled() ? 'disabled' : '';

  return (
    <div className={`presenter-active-slide-container ${isClickerTabOnMobile}`}>
      <div className="presenter-slide-carousel">
        <div className="presenter-slide-carousel-arrow presenter-slide-carousel_prev-arrow">
          <PrevArrowIcon className={prevArrowDisabledClass} onClick={goToPrevSlideAction}/>
        </div>
        <PresenterSlideView/>
        <div className="presenter-slide-carousel-arrow presenter-slide-carousel_next-arrow">
          <NextArrowIcon className={nextArrowDisabledClass} onClick={goToNextSlideAction}/>
        </div>
      </div>
      {isClickerMobileTab
        ? <Clicker
          prevArrowDisabledClass={prevArrowDisabledClass}
          nextArrowDisabledClass={nextArrowDisabledClass}
          onNextSlideHandler={goToNextSlideAction}
          onPrevSlideHandler={goToPrevSlideAction}
          numberOfSlides={getNumberOfSlides()}
          currentSlideIndex={getActivePointer().getCurrentCuePointIndex()}
          onFullscreenHandler={toggleFullscreenModeAction}
          />
        : <PresenterSlideDescription
          prevArrowDisabledClass={prevArrowDisabledClass}
          nextArrowDisabledClass={nextArrowDisabledClass}
          onNextSlideHandler={goToNextSlideAction}
          onPrevSlideHandler={goToPrevSlideAction}
          currentSlide={getActivePointer().getActiveItem().getCuePointMetadata()}
          numberOfSlides={getNumberOfSlides()}
          currentSlideIndex={getActivePointer().getCurrentCuePointIndex()}
          onFullscreenHandler={toggleFullscreenModeAction}
          />
      }
    </div>
  );
};

export default observer(PresenterSlideCarousel);

